import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types';
import DayPickerRanges from '../DayPickerRanges';
import Dropdown from '../Dropdown';
import { I18nFormatter } from '../../utils/I18n/I18n';

const DatePicker = ({startDate, endDate, onApply, className, id}) => {
    
    const [date, setDate] = useState({ startDate: startDate, endDate: endDate});
    const dropdownEl =  useRef(null)
    const images = {
        calendar: require('img/icons/calendar.svg'),
    };

    useEffect(() => {
        setDate({
            startDate: startDate,
            endDate: endDate
        });
    },[]);
    
    useEffect(() => {
        setDate({
            startDate: startDate,
            endDate: endDate
        });
    },[ endDate, startDate]);

    const onUpdateRange = (startDate, endDate) => {
          let dateValue = {
              startDate: startDate,
              endDate: endDate
          }
         setDate(dateValue);
         onApply(dateValue);
         onCancelRange();
    }

    const onCancelRange = () => {
        if (dropdownEl.current && typeof dropdownEl.current.onToggle === 'function') {
            dropdownEl.current.onToggle();
        }
    };
    
    let start = I18nFormatter.date(date.startDate);
    let end = I18nFormatter.date(date.endDate);
    let label = start;

    if (start !== end) {
        label += ` - ${end}`;
    }

    return (
        <Dropdown
            ref={dropdownEl}
            overlay={'body'}
            isCloseDocument={true}
            header={(
                <span className={className + ' bold'} id={id}>
                    {label}
                    <img src={images.calendar} alt=""/>
                </span>
            )}
        >
            <DayPickerRanges
                className={'dropdown-menu'}
                from={date.startDate}
                to={date.endDate}
                onAction={onUpdateRange}
                onCancel={onCancelRange}
            />
        </Dropdown>
    );
    
}

DatePicker.propTypes = {
    callbackParams: PropTypes.array,
    id: PropTypes.string
};

DatePicker.defaultProps = {
    callbackParams: []
};

export default DatePicker;
